<template>
  <div>
    <div class="bg-gray-600">
      <div class="mx-auto w-full max-w-9xl py-2">
        <div class="w-full p-4 md:py-0 md:px-12 text-sm md:text-base flex justify-between items-center">
          <div class="mt-1 mx-4 w-full flex justify-start">
            <inertia-link :href="route('dashboard.show')">
              <img src="/images/logo.png" class="h-10" alt="Casa Auto">
            </inertia-link>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-20">
      <div class="flex justify-center px-4 flex-col items-center">
        <h1 class="text-3xl font-bold text-center">
          {{ consent.consentForm.name }}
        </h1>
        <div class="text-lg text-gray-500 mt-4">{{ consent.client.name }}</div>
      </div>

      <div class="p-4 shadow-md mt-10 ">
        <div class="max-w-3xl w-full mx-auto mb-10 flex flex-col items-center">
          <form @submit.prevent="submitForm" class="w-full">
            <div>
              <div class="w-full text-lg p-4 border border-gray-400 bg-gray-300 leading-normal overflow-y-scroll consent-body" style="height: 800px;" v-html="consent.consentForm.body"></div>
            </div>

            <div class="mt-8">
              <checkbox-field :label="__('I agree with the terms and conditions')" v-model="form.accepted" name="accepted"/>
            </div>

            <div class="mt-10">
              <signature-pad :label="__('Signature')" v-model="form.signature" :data-error="error('signature')"></signature-pad>
            </div>

            <div class="flex justify-center items-center mt-16">
              <loading-button :loading="sendingForm" class="btn-primary" type="submit">{{ __("Save") }}</loading-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Layout from '@/Shared/Layout';
  import TextInput from '@/Shared/TextInput';
  import LoadingButton from '@/Shared/LoadingButton';
  import CheckboxField from '@/Shared/CheckboxField';
  import SignaturePad from '@/Shared/SignaturePad';
  import Icon from '@/Shared/Icon';

  export default {
    metaInfo() {
      return {
        title: this.__("Edit consent form"),
      }
    },
    props: {
      consent: Object
    },
    data() {
      return {
        form: {
          accepted: false,
          signature: null
        },
        sendingForm: false,
      }
    },
    components: {
      Layout,
      TextInput,
      LoadingButton,
      Icon,
      CheckboxField,
      SignaturePad
    },

    mounted() {
      window.Echo.private('consent-signing.' + this.$page.props.auth.user.id)
        .listen('ConsentSendToBeSignedEvent', (data) => {
          this.$inertia.visit(this.route('consents.edit', {consent: data.id}));
        });
    },

    methods: {
      submitForm() {
        this.sendingForm = true;
        this.$inertia.put(this.route('consents.update', {consent: this.consent.id}), this.form, {preserveState: false, preserveScroll: true});
      }
    }
  }
</script>
